import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { MenuButton } from '@reach/menu-button';
import '@reach/menu-button/styles.css';
import PropTypes from 'prop-types';
import { useMatch } from 'react-router-dom';

import { ACTIVE_STATE_CLASS_NAME } from 'consts';
import { FAIcon } from 'lib/customPropTypes';

import { Icon } from '../Icons';

import './styles/buttonStyles.css';

//  This component should be deprecated in favor of the <MenuButton/> in the __pds folder, however the custom styling requires it to have its own custom component.
//  It is currently not being used anywhere in Phoebe and should not be used without a discussion with design and frontend teams

const GlobalPrimaryDropdownButton = ({
  children,
  disabled,
  icon,
  path,
  ...rest
}) => {
  const activeMatch = useMatch(path);

  const className = activeMatch
    ? `button-subtle ${ACTIVE_STATE_CLASS_NAME}`
    : 'button-subtle';

  return (
    <MenuButton className={className} disabled={disabled} {...rest}>
      <div className="relative mb-1">
        <Icon icon={icon} size="lg" />
        <Icon
          aria-hidden
          className="absolute right-1/2 top-1/2 transform translate-x-6 -translate-y-1/2"
          icon={faChevronDown}
        />
      </div>
      <div className="mt-1">{children}</div>
    </MenuButton>
  );
};

GlobalPrimaryDropdownButton.defaultProps = {
  disabled: false,
};

GlobalPrimaryDropdownButton.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * The disabled state of the button
   */
  disabled: PropTypes.bool,
  /**
   * Icon to use for the button
   */
  icon: FAIcon.isRequired,
  /**
   * Path scope (i.e.: 'support/*')
   */
  path: PropTypes.string.isRequired,
};

export default GlobalPrimaryDropdownButton;
